/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCompanyStatisticDto } from '../models/work-company-statistic-dto';

@Injectable({ providedIn: 'root' })
export class WorkWebsiteStatisticsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `websiteStatisticsV2ControllerGetCompanyStatistics()` */
  static readonly WebsiteStatisticsV2ControllerGetCompanyStatisticsPath = '/v2/website/statistics/company';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteStatisticsV2ControllerGetCompanyStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteStatisticsV2ControllerGetCompanyStatistics$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCompanyStatisticDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteStatisticsV2Service.WebsiteStatisticsV2ControllerGetCompanyStatisticsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCompanyStatisticDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteStatisticsV2ControllerGetCompanyStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteStatisticsV2ControllerGetCompanyStatistics(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkCompanyStatisticDto>> {
    return this.websiteStatisticsV2ControllerGetCompanyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCompanyStatisticDto>>): Array<WorkCompanyStatisticDto> => r.body)
    );
  }

  /** Path part for operation `websiteStatisticsV2ControllerGetAmountOfBuiltProjects()` */
  static readonly WebsiteStatisticsV2ControllerGetAmountOfBuiltProjectsPath = '/v2/website/statistics/amount-of-built-projects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteStatisticsV2ControllerGetAmountOfBuiltProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteStatisticsV2ControllerGetAmountOfBuiltProjects$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCompanyStatisticDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteStatisticsV2Service.WebsiteStatisticsV2ControllerGetAmountOfBuiltProjectsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCompanyStatisticDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteStatisticsV2ControllerGetAmountOfBuiltProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteStatisticsV2ControllerGetAmountOfBuiltProjects(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkCompanyStatisticDto> {
    return this.websiteStatisticsV2ControllerGetAmountOfBuiltProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCompanyStatisticDto>): WorkCompanyStatisticDto => r.body)
    );
  }

}
